<div id="createWorkOrder" class="flex flex-col">
  <div class="flex flex-col justify-center sm:w-auto">
    <div class="mb-8 flex flex-col justify-center">
      <div class="flex sm:justify-center text-3xl sm:text-40px sm:font-rhetorik-sans mt-6">Create a Maintenance Request</div>
      <div class="flex flex-col sm:justify-center mt-2 px-0 sm:px-20 text-gray-tricon text-xl sm:text-xl">
        <div class="flex self-center">Begin by selecting a category from the list below.</div>
        <div class="font-bold text-starburst-orange my-2">If this is an emergency work order, please call <a href="tel:8448742661">844 874 2661</a></div>
      </div>
      <div class="max-w-600px self-center w-full">
        <div id="workOrderSelectCategory" class="flex justify-between">
          <mat-form-field class="w-1/2">
            <mat-label>Category</mat-label>
            <mat-select [(value)]="selectedGuide" (selectionChange)="onSelectGuide()">
              <mat-option *ngFor="let g of yonyxGuides" [value]="g">
                {{g.Title}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button [disabled]="bDisableLoadGuide" mat-flat-button color="primary" (click)="LoadGuide()"
            class="h-10 px-6 my-2">Load Guide</button>
        </div>
        <div id="yonyxGuide">
          <div id="yonyxEmbed" [hidden]="hideYonyxEmbed">
            <iframe id="yonyxAppFrame" frameborder="0" [src]="yonyxAppFrameSrc"></iframe>
          </div>
          <div *ngIf="bShowFormGuidanceStep" id="formGuidanceStep" class="w-full">
            <h4 class="text-2xl">{{guidanceStepTitle}}</h4>
            <div>{{guidanceStepBody}}</div>
            <h4 class="text-xl">{{guidanceStepQuestion}}</h4>
            <button *ngFor="let response of responses" (click)="onUserResponseClick(response.id)" type="button"
              class="btn btn-primary my-1">
              <div class="pl-2">
                {{response.body}}
              </div>
            </button>
            <button type="button" (click)="previousStep()" class="btn btn-primary back my-1">
              <div class="pl-2">
                Previous Step
              </div>
            </button>
          </div>
          <div *ngIf="bShowFormCreateWorkOrder && !isServerRequestPending && !submittedSuccessfully" class="w-full">
            <div class="text-xl">Problem Description</div>
            <textarea type="text" class="p-2 resize-none bg-gradient-b-light-gray w-full border-black"
              [(ngModel)]="problemDescription" name="probDesc" placeholder=" Please tell us about the maintenance issue in your own words. (optional)">
                    {{problemDescription}}
            </textarea>
            <button type="button" (click)="previousStep()" class="btn btn-primary back my-1">
              <div class="pl-2">
                Previous Step
              </div>
            </button>
            <button type="button" (click)="completeRequest()" class="btn btn-primary my-1">
              <div class="pl-2">
                Complete Request
              </div>
            </button>
            <button type="button" (click)="createAnother()" class="btn btn-primary my-1">
              <div class="pl-2">
                Create Another Request
              </div>
            </button>
          </div>
          <div *ngIf="isServerRequestPending && !submittedSuccessfully" class="flex justify-center"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>
        </div>
      </div>
    </div>
  </div>
</div>
